<template>
    <v-card flat>
        <v-card-title>
            <Button
                    width="248"
                    depressed
                    v-on:onClick="openCreateAllowedVendor"
                    class="my-3"
                    content="+ ADD VENDOR"
            />
            <v-spacer></v-spacer>
            <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
            ></v-text-field>
        </v-card-title>
        <v-data-table
                class="custom-table custom-table__header"
                :headers="headers"
                :items="allVendorsData"
                :loading="loading"
                :items-per-page="itemsPerPage"
                :page.sync="page"
                @update:sort-desc="handleSortDesc"
                @update:sort-by="handleSortBy"
                hide-default-footer
        >
            <template v-slot:item.actions="{ item }">
                <v-icon
                        small
                        class="mr-2"
                        @click="openEditItem(item)"
                        title="Edit client"
                >
                    mdi-pencil
                </v-icon>
            </template>
            <template v-slot:no-data> NO DATA </template>
        </v-data-table>
        <v-row class="align-center" v-if="allVendorsData.length">
            <v-col cols="12" sm="11" >
                <v-pagination
                        v-model="page"
                        :length="pageCount"
                        :total-visible="7"
                        @input="onChangePagination"
                ></v-pagination>
            </v-col>
            <v-col cols="12" sm="1">
                <v-select
                        :value="10"
                        :items="[5, 10, 15, 'All']"
                        label="Items per page"
                        @change="handleItemsPerPage"
                        hint="Items per page"
                        persistent-hint
                ></v-select>
            </v-col>
        </v-row>
        <v-dialog v-model="dialogCreate" max-width="500px" persistent>
            <v-card>
                <v-form
                        ref="create"
                        v-model="valid"
                        lazy-validation
                >
                    <v-card-title class="headline scan-header">{{ formTitle }}</v-card-title>
                    <v-card-text>
                        <v-container class="py-0">
                            <v-row>
                                <v-col cols="12" class="py-0">
                                    <v-text-field
                                            v-model="newVendor.name"
                                            label="Name"
                                            :rules="[v => !!v || 'This field is required']"
                                            required
                                            @input="onInputName"
                                    ></v-text-field>
                                    <v-row>
                                        <v-col cols="12" lg="12">
                                            <v-autocomplete
                                                v-model="newVendor.iab_vendor"
                                                :items="iabVendorsData"
                                                placeholder="IAB Vendor"
                                                item-value="id"
                                                :item-text="item => `(${item.iab_id})  ${item.iab_name}`"
                                                dense
                                                label="IAB Vendor"
                                                :rules="[autocompleteRule]"
                                                :loading="iabVendorsDataLoading"
                                                @input="e => {onInput(e, 'iab_vendor')}"
                                        ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" lg="12">
                                            <v-autocomplete
                                                v-model="newVendor.mspa_vendor_definition_id"
                                                :items="getMspaListData"
                                                placeholder="MSPA Signatory IDs"
                                                item-value="id"
                                                :item-text="item => `(${item.mspa_id})  ${item.signatory_legal_name}`"
                                                dense
                                                multiple
                                                hide-selected
                                                label="MSPA Signatory IDs"
                                                :rules="[autocompleteRule]"
                                                :loading="MSPAListLoading"
                                                @input="e => {onInput(e, 'mspa_vendor_definition_id')}"
                                        ></v-autocomplete>
                                        </v-col>
                                    </v-row>
                                    <v-row class="align-center" v-for="(n, index) in newVendor.sp_id" :key="index">
                                        <v-col cols="11" class="py-0">
                                            <v-text-field
                                                    class="pa-0"
                                                    v-model="newVendor.sp_id[index]"
                                                    label="Sourcepoint ID"
                                                    @input="onInputSpId"
                                                    :rules="[v => !!v || 'The value must not be empty']"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="1" class="py-0">
                                            <v-icon
                                                    v-if="newVendor.sp_id.length"
                                                    middle
                                                    title="Remove SP id"
                                                    @click="removeSpId(index)"
                                            >
                                                mdi-delete
                                            </v-icon>
                                        </v-col>
                                    </v-row>
                                    <div class="text-center"><v-btn color="primary" text @click="addSpId">+ Add Sourcepoint ID</v-btn></div>
                                    <v-text-field
                                            v-model="newVendor.google_atp_id"
                                            label="Google ATP ID"
                                            @input="e => {onInput(e, 'google_atp_id')}"
                                    ></v-text-field>
                                    <v-text-field
                                            v-model="newVendor.policy_url"
                                            label="Policy URL"
                                            @input="e => {onInput(e, 'policy_url')}"
                                    ></v-text-field>
                                    <v-text-field
                                            v-model="newVendor.compliance_details"
                                            label="Compliance details"
                                            @input="e => {onInput(e, 'compliance_details')}"
                                    ></v-text-field>
                                    <v-autocomplete
                                            v-model="newVendor.privacy_policy_flag"
                                            :items="[{value:0, text:'No privacy policy flag'},{value:1,text:'Privacy policy flagged'},{value:2,text:'No privacy policy'}]"
                                            placeholder="Privacy policy flag"
                                            label="Privacy policy flag"
                                            item-value="value"
                                            item-text="text"
                                            dense
                                            @input="e => {onInput(e, 'privacy_policy_flag')}"
                                    ></v-autocomplete>
                                    <v-autocomplete
                                            v-model="newVendor.google_atp_presence"
                                            :items="[{value:null, text:'unknown or not entered'},{value:false,text:'Is not a Google ATP provider'},{value:true,text:'Is a Google ATP vendor'}]"
                                            placeholder="Google ATP presence"
                                            item-value="value"
                                            item-text="text"
                                            dense
                                            label="Google ATP presence"
                                            @input="e => {onInput(e, 'google_atp_presence')}"
                                    ></v-autocomplete>
                                    <v-autocomplete
                                            v-model="newVendor.cookieless"
                                            :items="[{value:['deterministic'], text:'Deterministic'},{value:['probabilistic'],text:'Probabilistic'},{value:['hybrid'],text:'Hybrid'}]"
                                            placeholder="Cookieless ID"
                                            item-value="value"
                                            item-text="text"
                                            dense
                                            label="Cookieless ID"
                                            @input="e => {onInput(e, 'cookieless')}"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-container class="py-0">
                            <v-row>
                                <v-col cols="12" align="right">
                                    <v-btn color="red darken-1" text @click="closeCreate">Cancel</v-btn>
                                    <v-btn color="green darken-1" text @click="save">Save</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
    import Button from "../../common/Button";
    import { createNamespacedHelpers } from "vuex";
    const authHelper = createNamespacedHelpers("auth");
    const adminDashboardHelper = createNamespacedHelpers("adminDashboard");
    import adminDashboardApi from '../../../api/adminDashboard';

    const newVendorState = {
        name: '',
        iab_vendor: null,
        policy_url: '',
        privacy_policy_flag: 0,
        google_atp_presence: null,
        compliance_details: '',
        google_atp_id: null,
        sp_id: [],
        mspa_vendor_definition_id: [],
        cookieless: [],
    };
    export default {
        components: {Button},
        name: 'AllVendors',
        computed:{
            ...authHelper.mapGetters(["getSelectedClient"]),
            ...adminDashboardHelper.mapGetters(["getAllVendors", "getAllIabVendors", 'getMspaListData']),
            formTitle () {
                return this.editedIndex === -1 ? 'CREATE ALLOWED VENDOR' : 'EDIT ALLOWED VENDOR'
            },
        },
        data () {
            return {
                search: '',
                headers: [
                    { text: 'Name', align: 'start', value: 'name' },
                    { text: 'Sourcepoint ID', value: 'sp_id', sortable: false },
                    { text: 'IAB ID', value: 'iab_vendor', sortable: false },
                    { text: 'Actions', value: 'actions', sortable: false }
                ],
                allVendorsData: [],
                dialogCreate: false,
                loading: true,
                page: 1,
                pageCount: 1,
                itemsPerPage: 10,
                totalCount: 1,
                sortDesc: true,
                sort_field: "name",
                newVendor: { ...newVendorState },
                vendorId: '',
                editedIndex: -1,
                autocompleteRule: v =>{
                    if (v !== undefined) return true;
                    return 'This field is required';
                },
                valid: true,
                iabVendorsDataLoading: true,
                iabVendorsData: [],
                MSPAListLoading: false,
                vendorData : {}
            }
        },
        methods: {
            ...adminDashboardHelper.mapActions([ "fetchAllVendors", "fetchAllIabVendors", "fetchMSPA"]),
            async getAllIabVendorsData(){

                this.iabVendorsDataLoading = true;
                await this.fetchAllIabVendors({spec_version: 3});
                this.iabVendorsData = this.getAllIabVendors;
                this.iabVendorsDataLoading = false;

            },
            async getAllVendorsDashboard(){
                this.loading = true;
                await this.fetchAllVendors({
                    pagination: true,
                    page: this.page,
                    page_size: this.itemsPerPage < 0 ? this.pageCount : this.itemsPerPage,
                    sort: this.sortDesc ? "asc" : "desc",
                    s: this.search,
                    sort_field: this.sort_field ? 'vendor.' + this.sort_field : 'vendor.name'
                });
                this.loading = false;
            },
            async getMspaList(){
                this.MSPAListLoading = true;
                await this.fetchMSPA();
                this.MSPAListLoading = false;
            },
            openCreateAllowedVendor(){
                this.editedIndex = -1;
                this.dialogCreate = true;
            },
            openEditItem(vendor){
                this.vendorId = vendor.id;
                this.editedIndex = this.allVendorsData.indexOf(vendor);
                this.newVendor = Object.assign({},
                    {name: vendor.name},
                    {iab_vendor: vendor.iab_vendor_id},
                    {policy_url: vendor.policy_url},
                    {privacy_policy_flag: vendor.privacy_policy_flag},
                    {google_atp_presence: vendor.google_atp_presence},
                    {compliance_details: vendor.compliance_details},
                    {google_atp_id: vendor.google_atp_id},
                    {sp_id: vendor.sp_id ? vendor.sp_id : []},
                    {mspa_vendor_definition_id: vendor.mspa_vendor_definition_id ? vendor.mspa_vendor_definition_id : []},
                    {cookieless: vendor.cookieless ? vendor.cookieless : []},

                );
                this.dialogCreate = true;
            },
            closeCreate () {
                this.dialogCreate = false;
                this.newVendor = { ...newVendorState };
                this.vendorData = {};
                this.$refs.create.resetValidation();
            },
            async save(){
                if(this.$refs.create.validate()){
                    if(this.editedIndex > -1){
                        try{
                            await adminDashboardApi.updateVendor(this.vendorId, this.newVendor);
                            this.closeCreate();
                            this.getAllVendorsDashboard();
                        }catch(err){
                            alert(err.response ? err.response.data: err);
                        }
                    } else {
                        try{
                            await adminDashboardApi.createVendor(this.vendorData);
                            this.closeCreate();
                            this.getAllVendorsDashboard();
                        }catch(err){
                            const responseError = !['string', 'number', 'boolean'].includes(typeof err.response.data) ? JSON.stringify(err.response.data) : err.response.data; 
                            alert(err.response ? responseError : err)
                        }
                    }

                }
            },
            handleItemsPerPage(itemsPerPage){
                this.page = 1;
                if(itemsPerPage === 'All'){
                    this.itemsPerPage = this.totalCount;
                } else {
                    this.itemsPerPage = itemsPerPage;
                }
                this.getAllVendorsDashboard();
            },
            handleSortDesc(desc){
                if( this.sortDesc !== desc[0] && desc.length){
                    this.sortDesc = desc[0];
                    this.getAllVendorsDashboard();
                }
            },
            handleSortBy(sortBy){
                if(this.sort_field !== sortBy[0] && sortBy.length){
                    this.sort_field = sortBy[0];
                    this.getAllVendorsDashboard();
                }
            },
            onChangePagination(){
                this.getAllVendorsDashboard();
            },
            onInputName(e){
                this.vendorData.name = e;
            },
            onInput(e, paramName){
                if( e === undefined || e === ''){
                    delete this.vendorData[paramName];
                    if(this.vendorData[paramName] === undefined || this.vendorData[paramName] === '') {
                        this.newVendor[paramName] = null
                    }
                } else{
                    this.vendorData[paramName] = e;
                }
            },
            onInputSpId(){
                this.vendorData.sp_id = this.newVendor.sp_id
            },
            addSpId(){
                this.newVendor.sp_id.push('');
            },
            removeSpId(index){
                this.newVendor.sp_id.splice(index, 1);
                if(!this.newVendor.sp_id.length){
                    delete this.vendorData.sp_id;
                }
            }
        },
        created () {
            this.getAllVendorsDashboard();
            this.getAllIabVendorsData();
            this.getMspaList();
        },
        watch: {
            getAllVendors: function(e){
                this.allVendorsData = e.results;
                this.pageCount = Math.ceil(e.count/this.itemsPerPage);
                this.totalCount = e.count;
            },
            search: function(){
                this.page = 1;
                this.getAllVendorsDashboard();
            },
            getSelectedClient: function() {
                this.getAllVendorsDashboard();
            },
        }
    }
</script>
